import { createReducer } from "@reduxjs/toolkit";
import {
	API_ASSIGN_SECRETARY_PRESCRIPTION_FAIL,
	API_VALIDATE_PRESCRIPTION_FAIL,
	API_SET_SAMPLER_PRESCRIPTION,
	API_SET_SAMPLER_PRESCRIPTION_FAIL,
	API_SET_SAMPLER_PRESCRIPTION_SUCCESS,
	API_GET_FPA_PDF,
	API_GET_FPA_PDF_FAIL,
	API_GET_FPA_PDF_SUCCESS,
	API_GET_REPEATABLE_PRESCRIPTION,
	API_GET_REPEATABLE_PRESCRIPTION_FAIL,
	API_GET_REPEATABLE_PRESCRIPTION_SUCCESS,
	API_GET_SCANS_SUCCESS,
	API_GET_SCANS_FAIL,
	API_GET_SCANS,
	API_DELETE_SCAN_ORDO_SUCCESS,
	API_GET_MY_SECU_CHECK,
	API_GET_MY_SECU_CHECK_SUCCESS,
	CLEAN_SCANS,
	CLEAN_MY_SECU_CHECK,
	API_GET_DSP_PRESCRIPTION_SUCCESS,
	API_GET_EPN_PDF_SUCCESS,
} from "actions/prescription";
import { ErrorAction, errorHandler } from "utils/error";
import { toast } from "react-toastify";

const initialState = {
	repeatable: {
		data: [],
		loading: false,
	},
	loading: false,
	fpaPdf: null,
	safeplace: null,
	tvSecScans: [],
	loadingScans: false,
	mysecuCheck: null,
	scans: [],
	epnPdf: null,
};

const prescriptions = createReducer(initialState, {
	[API_VALIDATE_PRESCRIPTION_FAIL]: (state, action) => {
		errorHandler("Prescription", ErrorAction.UPDATE, action.error);
	},

	[API_ASSIGN_SECRETARY_PRESCRIPTION_FAIL]: (state, action) => {
		toast.error("Cette prescription a été assignée depuis. Veuillez en sélectionner une autre");
	},

	/** ASSIGN PRESCRIPTION **/
	[API_SET_SAMPLER_PRESCRIPTION]: (state, action) => {
		state.loading = true;
	},
	[API_SET_SAMPLER_PRESCRIPTION_FAIL]: (state, action) => {
		state.loading = false;
	},
	[API_SET_SAMPLER_PRESCRIPTION_SUCCESS]: (state, action) => {
		state.loading = false;
	},

	/** GET FPA **/
	[API_GET_FPA_PDF]: (state, action) => {
		state.loading = true;
		state.fpaPdf = null;
	},
	[API_GET_FPA_PDF_FAIL]: (state, action) => {
		state.loading = false;
		state.fpaPdf = null;
		errorHandler("FPA", ErrorAction.READ, action.error);
	},
	[API_GET_FPA_PDF_SUCCESS]: (state, action) => {
		state.loading = false;
		state.fpaPdf = action.payload.data;
	},

	/** GET REPEATABLE **/
	[API_GET_REPEATABLE_PRESCRIPTION]: (state, action) => {
		state.repeatable = { loading: true, list: null };
	},
	[API_GET_REPEATABLE_PRESCRIPTION_FAIL]: (state, action) => {
		state.repeatable = { loading: false, list: null };
		errorHandler("Prescription renouvelable", ErrorAction.READ, action.error);
	},
	[API_GET_REPEATABLE_PRESCRIPTION_SUCCESS]: (state, action) => {
		state.repeatable = { loading: false, list: action.payload.data };
	},
	[API_GET_SCANS]: (state, action) => {
		state.loadingScans = true;
	},
	[API_GET_SCANS_SUCCESS]: (state, action) => {
		state.loadingScans = false;
		state.tvSecScans = action.payload.data.scans && action.payload.data.scans.length > 0 ? action.payload.data.scans.flatMap((d) => d) : [];
	},
	[API_GET_SCANS_FAIL]: (state, action) => {
		state.loadingScans = false;
		state.tvSecScans = [];
		errorHandler("Scans TvSecrétariat", ErrorAction.READ, action.error);
	},
	[API_DELETE_SCAN_ORDO_SUCCESS]: (state, action) => {
		const url = action.meta.previousAction.payload.request.url;
		state.tvSecScans = state.tvSecScans.filter((s) => s.id !== parseInt(url.substring(url.lastIndexOf("/") + 1)));
	},
	[CLEAN_SCANS]: (state, action) => {
		state.tvSecScans = [];
	},
	[API_GET_MY_SECU_CHECK]: (state, action) => {
		state.mysecuCheck = null;
	},
	[CLEAN_MY_SECU_CHECK]: (state, action) => {
		state.mysecuCheck = null;
	},
	[API_GET_MY_SECU_CHECK_SUCCESS]: (state, action) => {
		state.mysecuCheck = action.payload.data;
	},
	[API_GET_DSP_PRESCRIPTION_SUCCESS]: (state, action) => {
		state.eprescriptionAgence = action.payload.data;
	},

	[API_GET_EPN_PDF_SUCCESS]: (state, action) => {
		state.epnPdf = action.payload.data;
	},
});

export default prescriptions;
